// BM üyesi 193 ülke + 2 gözlemci (Vatikan, Filistin) = 195 ülke (Türkçe adlar).
// Tüm tenant'larda otomatik kullanılabilir statik liste.
const RAW = [
  "Afganistan", "Almanya", "Amerika Birleşik Devletleri", "Andorra", "Angola",
  "Antigua ve Barbuda", "Arjantin", "Arnavutluk", "Avustralya", "Avusturya",
  "Azerbaycan", "Bahamalar", "Bahreyn", "Bangladeş", "Barbados", "Belarus",
  "Belçika", "Belize", "Benin", "Bhutan", "Birleşik Arap Emirlikleri",
  "Birleşik Krallık", "Bolivya", "Bosna-Hersek", "Botsvana", "Brezilya",
  "Brunei", "Bulgaristan", "Burkina Faso", "Burundi", "Cezayir", "Cibuti",
  "Çad", "Çekya", "Çin", "Danimarka", "Doğu Timor", "Dominik Cumhuriyeti",
  "Dominika", "Ekvador", "Ekvator Ginesi", "El Salvador", "Endonezya",
  "Eritre", "Ermenistan", "Estonya", "Esvatini", "Etiyopya", "Fas", "Fiji",
  "Fildişi Sahili", "Filipinler", "Filistin", "Finlandiya", "Fransa", "Gabon",
  "Gambiya", "Gana", "Gine", "Gine-Bissau", "Grenada", "Guatemala", "Guyana",
  "Güney Afrika", "Güney Kore", "Güney Sudan", "Gürcistan", "Haiti",
  "Hindistan", "Hırvatistan", "Hollanda", "Honduras", "Irak", "İran",
  "İrlanda", "İspanya", "İsrail", "İsveç", "İsviçre", "İtalya", "İzlanda",
  "Jamaika", "Japonya", "Kamboçya", "Kamerun", "Kanada", "Kap Verde",
  "Karadağ", "Katar", "Kazakistan", "Kenya", "Kıbrıs", "Kırgızistan",
  "Kiribati", "Kolombiya", "Komorlar", "Kongo Cumhuriyeti",
  "Kongo Demokratik Cumhuriyeti", "Kosta Rika", "Kuveyt", "Kuzey Kore",
  "Kuzey Makedonya", "Küba", "Laos", "Lesotho", "Letonya", "Liberya", "Libya",
  "Lihtenştayn", "Litvanya", "Lübnan", "Lüksemburg", "Macaristan",
  "Madagaskar", "Malavi", "Maldivler", "Malezya", "Mali", "Malta",
  "Marshall Adaları", "Meksika", "Mısır", "Mikronezya", "Moğolistan",
  "Moldova", "Monako", "Moritanya", "Morityus", "Mozambik", "Myanmar",
  "Namibya", "Nauru", "Nepal", "Nijer", "Nijerya", "Nikaragua", "Norveç",
  "Orta Afrika Cumhuriyeti", "Özbekistan", "Pakistan", "Palau", "Panama",
  "Papua Yeni Gine", "Paraguay", "Peru", "Polonya", "Portekiz", "Romanya",
  "Ruanda", "Rusya", "Saint Kitts ve Nevis", "Saint Lucia",
  "Saint Vincent ve Grenadinler", "Samoa", "San Marino",
  "Sao Tome ve Principe", "Senegal", "Seyşeller", "Sırbistan", "Sierra Leone",
  "Singapur", "Slovakya", "Slovenya", "Solomon Adaları", "Somali",
  "Sri Lanka", "Sudan", "Surinam", "Suriye", "Suudi Arabistan", "Şili",
  "Tacikistan", "Tanzanya", "Tayland", "Togo", "Tonga",
  "Trinidad ve Tobago", "Tunus", "Tuvalu", "Türkiye", "Türkmenistan",
  "Uganda", "Ukrayna", "Umman", "Uruguay", "Ürdün", "Vanuatu", "Vatikan",
  "Venezuela", "Vietnam", "Yemen", "Yeni Zelanda", "Yunanistan", "Zambiya",
  "Zimbabve",
];

export const UN_COUNTRIES = [...RAW].sort((a, b) => a.localeCompare(b, "tr"));
